import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandMark from "./BrandMark";
import Footer from "./Footer";

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="font-serif text-xl font-medium tracking-tight text-guinep-ink sm:text-2xl">
      {title}
    </h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-guinep-mute sm:text-base">
      {children}
    </div>
  </section>
);

export const LegalList = ({ items }) => (
  <ul className="list-disc space-y-1.5 pl-5">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);

const LegalPage = ({ title, updated, children, testid }) => (
  <div className="min-h-screen bg-white font-sans" data-testid={testid}>
    <header className="sticky top-0 z-50 border-b border-guinep-line/50 bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" data-testid="legal-nav-logo" className="flex items-center gap-2">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-guinep-soft">
            <BrandMark size={17} />
          </span>
          <span className="font-serif text-lg font-semibold tracking-tight text-guinep-ink">
            Guinep Seed
          </span>
        </Link>
        <Link
          to="/"
          data-testid="legal-back-home-link"
          className="group inline-flex items-center gap-1.5 text-sm font-medium text-guinep-mute transition-colors duration-300 hover:text-guinep-ink"
        >
          <ArrowLeft size={15} className="transition-transform duration-300 group-hover:-translate-x-0.5" />
          Back to home
        </Link>
      </div>
    </header>

    <main className="mx-auto max-w-3xl px-5 py-14 sm:px-8 sm:py-20">
      <p className="text-xs font-semibold uppercase tracking-[0.28em] text-guinep-mid">Guinep Seed</p>
      <h1 className="mt-4 font-serif text-4xl font-medium tracking-tight text-guinep-ink sm:text-5xl">
        {title}
      </h1>
      {updated && <p className="mt-3 text-sm text-guinep-mute">Last updated: {updated}</p>}
      <div className="mt-12 space-y-10">{children}</div>
    </main>

    <Footer />
  </div>
);

export default LegalPage;
